export default {
  fields: {
    city_id: {
      readOnly: true,
    },
    tag_id: {
      readOnly: true,
    },
    landmark_id: {
      readOnly: true,
    },
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    }
  },
  relationships: {
    city: 'cities',
    tag: 'tags',
    landmark: 'landmarks',
  },
}
